import { render, staticRenderFns } from "./BaseInputEmail.vue?vue&type=template&id=bc96824a"
import script from "./BaseInputEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseInputEmail.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports